import React, { useEffect } from "react";

import {
  mxpBlogPostViewed,
  mxpPageViewed,
} from "../../utils/mixpanelEvents/mixpanelEvents";
import { SEOContext } from "gatsby-plugin-wpgraphql-seo";
import DefaultPollenNavContainer from "../../containers/DefaultPollenNavContainer";
import generateUuId from "../../utils/generateUuId";
import LayoutSEOQuery from "../../assets/StaticQueries/LayoutSEO.query";
import useGtmPageChange from "../../hooks/useGtmPageChange";
import { PollenConsultBannerQuery } from "../../assets/StaticQueries/PollenConsultBannerQuery.query";
import PollenConsultBanner from "../../components/Banners/PollenConsultBanner/PollenConsultBanner";
import PollenFooter from "../../components/Footers/PollenFooter/PollenFooter";
import usePollenOptionsStore from "@sp-state/usePollenOptionsStore";

import "../main.scss";
import DefaultFooter from "@layouts/DefaultFooter";

type DefaultPollenLayoutType = {
  children: React.ReactNode;
  isTracked?: boolean;
  noBanner?: boolean;
  noFooter?: boolean;
  pathname: string;
};

const DefaultPollenLayout: React.FC<DefaultPollenLayoutType> = ({
  children,
  isTracked = true,
  noBanner,
  noFooter,
  pathname,
}) => {
  const { setPollenOptionsData } = usePollenOptionsStore(state => state);
  const uuid = generateUuId();
  const banner = PollenConsultBannerQuery();

  useEffect(() => {
    if (isTracked) {
      mxpPageViewed();
    }
    setPollenOptionsData();
    mxpBlogPostViewed();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useGtmPageChange(uuid);

  const seo = LayoutSEOQuery();

  const options = {
    schemaReplacement: {
      from: "https://spgatsby.wpengine.com",
      to: "https://www.simplepractice.com",
    },
  };

  return (
    <SEOContext.Provider value={{ global: seo, options }}>
      <DefaultPollenNavContainer />
      <main>{children}</main>
      {!noFooter && <PollenFooter />}
      {!noBanner && banner?.addConsultCtaBanner && (
        <PollenConsultBanner banner={banner} />
      )}
      <DefaultFooter pathname={pathname} />
    </SEOContext.Provider>
  );
};

export default DefaultPollenLayout;
